<template>
  <div class="twitter-post-preview-body-advanced-head">
    <div v-if="msg" class="twitter-post-preview-body-advanced-head__message" v-html="msg"></div>
    <a
      v-if="link"
      :href="link"
      target="_blank"
      class="twitter-post-preview-body-advanced-head__link"
    >
      {{ link }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    link: String,
    msg: String,
  },
};
</script>

<style lang="scss" scoped>
.twitter-post-preview-body-advanced-head {
  min-height: 20px;
  &__message,
  &__link {
    padding-bottom: 5px;
    font-size: 14px;
  }
  &__link {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #299ded;
    max-width: 360px;
  }
}
</style>
